import { PaymentsModalType, SubscriptionDataModel } from "entities/shared/subscriptionModel";
import { useSearchQuery } from "./useSearchQuery";

const OPENED_CARD_CACHE_KEY = "opened-card-airtracking-request";

export const useOpenedCardSearchQuery = ({
  isAuthenticated,
  setSubscription,
  setActivePaymentModal,
  setAppIntegrationRequestLimitReached,
  setWebAppRequestLimitReached,
}: {
  isAuthenticated: boolean;
  setSubscription: (subscription: SubscriptionDataModel) => {
    type: string;
    payload: SubscriptionDataModel | null;
  };
  setActivePaymentModal: (activePaymentModal: PaymentsModalType) => {
    type: string;
    payload: PaymentsModalType | null;
  };
  setAppIntegrationRequestLimitReached: (appIntegrationRequestLimitReached: boolean) => {
    type: string;
    payload: boolean | null;
  };
  setWebAppRequestLimitReached: (webAppRequestLimitReached: boolean) => {
    type: string;
    payload: boolean | null;
  };
}): ReturnType<typeof useSearchQuery> => {
  return useSearchQuery({
    queryKey: [OPENED_CARD_CACHE_KEY],
    isAuthenticated,
    setSubscription,
    setActivePaymentModal,
    setAppIntegrationRequestLimitReached,
    setWebAppRequestLimitReached,
  });
};
